module.exports = __webpack_public_path__ + "media/images/logo-2581fcc5.png";